/**
 * CMS rich-text editors often strip nested wrappers (e.g. __item, __itemBody)
 * and may nest __itemTitle inside __icon when tags are not explicitly closed.
 * Rebuilds the DOM structure expected by _outlineBoard.scss.
 */
export function structureOutlineBoard(root) {
  if (!root) return;

  const containers = [];
  if (root.classList.contains('outline-board')) {
    containers.push(root);
  }
  root.querySelectorAll('.outline-board').forEach((el) => {
    if (!containers.includes(el)) {
      containers.push(el);
    }
  });

  containers.forEach((container) => {
    if (container.querySelector('.outline-board__item')) {
      return;
    }

    const list = container.querySelector('.outline-board__list') || container;
    const icons = [...list.querySelectorAll('.outline-board__icon')];

    icons.reverse().forEach((iconEl) => {
      let titleEl = iconEl.querySelector(':scope > .outline-board__itemTitle');
      if (!titleEl) {
        titleEl = iconEl.nextElementSibling;
      }
      if (!titleEl || !titleEl.classList.contains('outline-board__itemTitle')) {
        return;
      }

      const item = document.createElement('div');
      item.className = 'outline-board__item';
      const body = document.createElement('div');
      body.className = 'outline-board__itemBody';

      const parent = iconEl.parentNode;
      parent.insertBefore(item, iconEl);
      item.appendChild(iconEl);
      item.appendChild(body);
      body.appendChild(titleEl);
    });

    if (!container.querySelector('.outline-board__callout')) {
      const calloutTitle = container.querySelector('.outline-board__calloutTitle');
      if (calloutTitle) {
        const calloutDesc = container.querySelector('.outline-board__calloutDesc');
        const callout = document.createElement('div');
        callout.className = 'outline-board__callout';
        calloutTitle.parentNode.insertBefore(callout, calloutTitle);
        callout.appendChild(calloutTitle);
        if (calloutDesc) {
          callout.appendChild(calloutDesc);
        }
      }
    }
  });
}
